import { Component, Input,OnChanges,SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { QuestionBase } from '../../../components/sample/model/question-base';


@Component({
  selector: 'datepicker-question',
  template:`<div [formGroup]="form">
  
  <kendo-formfield>
            <kendo-floatinglabel  [text]="question.label">
              <kendo-datepicker [formControlName]="question.key" [id]="question.key" placeholder="" 
              [min]="question.minDate ? question.minDate:null" [max]="question.maxDate ? question.maxDate:null"
              [disabled]=" question.value && question.disabled" >
              </kendo-datepicker>
            </kendo-floatinglabel>
            <kendo-formhint *ngIf="question.hint" align="start">
           {{question.hint}}
          </kendo-formhint>
       <kendo-formerror *ngIf="form.controls[question.key].errors?.required">Error: {{errorRequired.value}}</kendo-formerror>
          </kendo-formfield>
</div>`
})
export class DatepickerFormQuestionComponent  implements OnChanges {
  @Input() question!: QuestionBase<any>;
  @Input() form!: FormGroup;

  errorRequired: { key: string; value: string; };
  // errorMax: { key: string; value: string; };
  // errorMin: { key: string; value: string; };

  ngOnChanges(changes: SimpleChanges) {
    if(changes.question.firstChange){ 
      console.log('changes.questiondate',changes.question)
      this.errorRequired = changes.question.currentValue.errors.find( ({ key }) => key === 'required' )
      // this.errorMax = changes.question.currentValue.errors.find( ({ key }) => key === 'maxLength' )
      // this.errorMin = changes.question.currentValue.errors.find( ({ key }) => key === 'minLength' )
    }
  }
}